import Model from './Model'

export default class ProductType extends Model {
    resource()
    {
        return 'product-types'
    }

    // ! Not tested yet
    toFilterOptions(models) {
        if (!Array.isArray(models)) return [];
        return models.map(model => ({
            value: String(model.id),
            label: model.name,
        }));
    }
}